import { observer } from 'mobx-react-lite';

import { Button, Heading, Skeleton, Text } from '@flixbus/honeycomb-react';

import WarningBanner from 'common/WarningBanner';
import personalTimelineStore from 'pages/CrewMemberDetails/components/PersonalTimeline/PersonalTimelineStore';

import HoldDownWarning from '../HoldDownWarning';
import { crewMemberInfoText } from '../text';
import { getCurrentHoldDown } from '../utils/getCurrentHoldDown';
import { isUsedHoursLessThanOne } from '../utils/hoursTracking';

import styles from './styles.module.css';

const Identification = observer(({ loading, error, employeeInfo, onOpenEditPanel }) => {
	if (loading || error) {
		return (
			<div className={styles.idLoader}>
				<Skeleton width="sm" height="lg" />
				<Skeleton width="sm" height="sm" />
			</div>
		);
	}

	if (employeeInfo == null) return null;

	const { fullName, driverCard, hoursTracking, holdDowns = [] } = employeeInfo;
	const replacementHoldDown = getCurrentHoldDown(holdDowns, employeeInfo);
	const {
		drivingMinutesBalance,
		drivingMinutesLimit,
		dutyMinutesBalance,
		dutyMinutesLimit,
		eightDaysDutyMinutesBalance,
		eightDaysDutyMinutesLimit,
	} = hoursTracking ?? {};
	const hasHoursWarning =
		personalTimelineStore.isDriverInActiveShift &&
		hoursTracking &&
		(isUsedHoursLessThanOne(drivingMinutesBalance, drivingMinutesLimit) ||
			isUsedHoursLessThanOne(dutyMinutesBalance, dutyMinutesLimit) ||
			isUsedHoursLessThanOne(eightDaysDutyMinutesBalance, eightDaysDutyMinutesLimit));

	return (
		<div className={styles.container}>
			<div className={styles.identification}>
				<div className={styles.credentials}>
					<Heading flushSpace size={1}>
						{fullName}
					</Heading>
					<Text>{`${crewMemberInfoText.employeeNumber}: ${driverCard ?? '-'}`}</Text>
				</div>
				<Button role="button" onClick={onOpenEditPanel} extraClasses={styles.settingsBtn}>
					{crewMemberInfoText.editButton}
				</Button>
			</div>
			{hasHoursWarning && (
				<WarningBanner>
					<strong>{crewMemberInfoText.hoursWarningTitle}</strong>{' '}
					{crewMemberInfoText.hoursWarningDescription}
				</WarningBanner>
			)}
			<HoldDownWarning holdDown={replacementHoldDown} />
		</div>
	);
});

export default Identification;
